import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchAISystemsSummary } from '../../services/AISystemsService'
import { AISystemSummaryDto } from '../../types/AISystems.types'

interface SummaryState {
  data: AISystemSummaryDto | null
  loading: boolean
  error: string | null
}

const initialState: SummaryState = {
  data: null,
  loading: false,
  error: null,
}

// Async thunk za fetch summary podataka
export const fetchSummaryData = createAsyncThunk(
  'summary/fetchSummaryData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchAISystemsSummary()
      return response
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch summary data')
    }
  }
)

const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {
    clearSummaryError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummaryData.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSummaryData.fulfilled, (state, action: PayloadAction<AISystemSummaryDto>) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchSummaryData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { clearSummaryError } = summarySlice.actions
export default summarySlice.reducer